"use client";
import { createContext } from "react";
//#region packages/@mantine/core/src/components/Input/Input.context.ts
const InputContext = createContext({ size: "sm" });
//#endregion
export { InputContext };

//# sourceMappingURL=Input.context.mjs.map